/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".ms-SearchBoxSmallExample{width:208px}"}]);
/* tslint:enable */